import Card from "components/card";
import React, { useEffect, useState } from "react";
import { useRef } from "react";
import { ESService } from "services/esService";
import { useSelector } from "react-redux";
import { currentUser } from "services/users/authSlice";
import ApiList from "services/apiList";
import CustomButton from "components/button/custom_button";
const MyCourse = () => {
  const [data, setData] = useState({});
  const [visibleAll, setVisibleAll] = useState(false);
  var user = useSelector(currentUser);
  const mount = useRef(true);

  const showMoreItems = () => {
    setVisibleAll(!visibleAll);
  };
  useEffect(() => {
    if (mount.current) {
      mount.current = false;
      const token = user.token;
      const es = new ESService(token);
      es.get(ApiList.teacherCourseUrl).then((json) => {
        if (json["status"]) {
          setData(json["data"]);
        }
      });
    }
  }, [user]);

  return (
    <Card extra={"w-full p-4 h-full"}>
      <div className="mb-4 w-full">
        <h4 className="text-xl font-bold text-navy-700 dark:text-white">
          Дааж авсан анги {data.number}
          {data.group}
        </h4>
        <p className="mt-2 text-base text-gray-600">
          {data.classroom === null || data.classroom === undefined
            ? "Үндсэн анги танхим байхгүй байна"
            : data.classroom.number === null ||
              data.classroom.number === undefined
            ? "Үндсэн анги танхим байхгүй байна"
            : "Үндсэн анги " + data.classroom.number}
        </p>
      </div>

      {data.students === null || data.students === undefined ? (
        <span></span>
      ) : (
        data.students.map((row, i) => {
          return (
            <div
              style={{
                transition: "opacity 0.5s, height 0.5s",
                opacity: i < 10 || visibleAll ? 1 : 0,
                height: i < 10 || visibleAll ? "auto" : 0,
                overflow: "hidden",
              }}
            >
              <div
                key={"lessons" + i}
                R
                className="flex w-full items-center justify-between rounded-2xl bg-white p-3 shadow-3xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none"
              >
                <div className="flex items-center">
                  <div className="ml-4">
                    <p className="text-base font-medium text-navy-700 dark:text-white">
                      {row.lastname} {row.firstname}
                    </p>
                    <p className="mt-2 text-sm text-gray-600">{row.username}</p>
                  </div>
                </div>
                <div className="mr-4 flex cursor-pointer items-center justify-center text-gray-600 dark:text-white">
                  {/* GENDER ORJ IRNE ENE DEER */}
                </div>
              </div>
            </div>
          );
        })
      )}
      <CustomButton
        onClick={showMoreItems}
        text={!visibleAll ? "Бүгдийг нь харах" : "Хураангуйлах"}
        type="button"
      />
    </Card>
  );
};

export default MyCourse;
